export default "__VITE_ASSET__BuSXOXq$__"